import { Link } from 'react-router-dom';

import Layout from '../../components/Layout.js';
import InfoCard from '../home/InfoCard.js';
import LazyImg from '../../components/LazyImg.js';

import ExperienceSnapshot from './ExperienceSnapshot.js';
import PublicationCallout from './PublicationCallout.js';
import TechStack from './TechStack.js';

import pbkLogo from '../../assets/logos/pbk.avif';
import urLogo from '../../assets/logos/ur.jfif';
import melLogo from '../../assets/logos/mel.png';

import trisImg from '../../assets/projectPreview/tris-logo.png';
import turingImg from '../../assets/projectPreview/tt.png';
import pressureImg from '../../assets/projectPreview/under-pressure.gif';
import flameImg from '../../assets/projectPreview/flame-gif.gif';

import './about.css';


function About() {
    return (
        <Layout pageIndex={1}>

            {/* ── INTRO ──────────────────────────────────────────── */}
            <section className="about-hero page-hero noise">
                <div className="about-page-header">

                    <div>
                        <p className="section-eyebrow">Who I am</p>
                        <h1 className="about-hero-name">Hi, I'm Michael!</h1>

                        <p className="exp-page-sub">
                            New York, NY
                        </p>

                    </div>

                    <LazyImg
                        imageKey="bench"
                        className="about-hero-photo"
                        alt="Me sitting on a bench"
                        isBackgroundFilled={false}
                        style={{ width: "220px", boxShadow: "none", borderRadius: "0px", marginLeft: "auto", transform: "translateY(-16px)" }}
                    />

                </div>
            </section>

            <hr />


            <section className="about-section">
                <p className="section-eyebrow">The short version</p>
                <h2 className="section-title">About me</h2>
                <p className="about-body-text">
                    I'm a software engineer with a focus on <strong className="bio-highlight">full-stack development</strong> and{' '}
                    <strong className="bio-highlight">applied ML</strong>. I spent most of college doing both AI image
                    detection research (published at <strong className="bio-highlight">IEEE BigData 2023</strong>) and
                    proving complexity results in computational social choice through an NSF REU. On the side I
                    build tools, apps, and games with my friends, one of which has <strong className="bio-highlight">200+ active users</strong>.
                </p>
            </section>



            <hr />

         


{/* ── FEATURED PUBLICATION ───────────────────────────── */}
            {/* <PublicationCallout />

            <hr /> */}
            




            {/* ── EDUCATION ──────────────────────────────────────── */}
            <section className="about-section">
                <p className="section-eyebrow">Academic background</p>
                <h2 className="section-title">Education</h2>

                <div className="education-card">
                    <div className="education-card-logo">
                        <img src={melLogo} alt="Hajim School of Engineering logo" className="education-logo" />
                    </div>

                    <div className="education-card-body">
                        <div className="education-header">
                            <div>
                                <h3 className="education-school">University of Rochester — Hajim School of Engineering</h3>
                                <p className="education-degree">B.S. in Computer Science · Mathematics Minor</p>
                                <p className="education-meta">Cum Laude, High Distinction · GPA 3.87 / 4.0</p>
                            </div>



                        </div>


                        <div>
                            {[
                                {
                                    logo: pbkLogo,
                                    alt: 'Phi Beta Kappa logo',
                                    title: 'Phi Beta Kappa',
                                    desc: "America's most prestigious honor society — awarded as one of UR's top 2025 graduates.",
                                },
                                {
                                    logo: urLogo,
                                    alt: 'UR logo',
                                    title: 'Excellence in Undergraduate Research Award',
                                    desc: 'Awarded for significant research achievements including publications and conference presentations.',
                                },
                                {
                                    logo: urLogo,
                                    alt: 'UR logo',
                                    title: 'Undergraduate Research Grant',
                                    desc: 'Funded the publication of an IEEE paper on deep learning for AI content detection.',
                                },
                                {
                                    logo: urLogo,
                                    alt: 'UR logo',
                                    title: 'Xerox Technology Scholarship',
                                    desc: 'Awarded for excellence and passion in information technology and computer science.',
                                },
                            ].map(award => (
                                <div className="award-item" key={award.title}>
                                    <img loading="lazy" src={award.logo} alt={award.alt} className="award-logo" />
                                    <div>
                                        <strong className="award-title">{award.title}</strong>
                                        <p className="award-desc">{award.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <hr />

               {/* ── EXPERIENCE ─────────────────────────────────────── */}
            <ExperienceSnapshot />

            

            < hr/>

            {/* ── HACKATHONS ─────────────────────────────────────── */}
            <section className="about-section">
                <p className="section-eyebrow">Game jams &amp; hackathons</p>
                <h2 className="section-title">Games I've built</h2>
                <p className="about-body-text">
                    I regularly competed in hackathons with friends, racking up four first-place finishes.
                </p>

                <div className="game-grid">
                    {[
                        { href: '/projects/two-tris', img: trisImg, alt: '2-Tris', event: "Dandyhacks '22", name: '2-Tris', awards: ['🥇 1st Place — Entertainment Track', '🥇 Best UI/UX'] },
                        { href: '/projects/turing-trouble', img: turingImg, alt: 'Turing Trouble', event: "Dandyhacks '23", name: 'Turing Trouble', awards: ['🥇 1st Place — Entertainment Track'] },
                        { href: '/projects/under-pressure', img: pressureImg, alt: 'Under Pressure', event: "Dandyhacks '24", name: 'Under Pressure', awards: ['🥇 1st Place — Entertainment Track', '🥇 1st Place Overall'] },
                        { href: '/projects/flames-legacy', img: flameImg, alt: "Flame's Legacy", event: "Excalibur '25", name: "Flame's Legacy", awards: ['🥇 1st Place Overall'] },
                    ].map(g => (
                        <Link to={g.href} className="game-card" key={g.name}>
                            <img loading="lazy" src={g.img} alt={g.alt} className="game-card-img" />
                            <div className="game-card-body">
                                <span className="project-tag">{g.event}</span>
                                <h3 className="game-card-title">{g.name}</h3>
                                <ul className="game-card-awards">
                                    {g.awards.map(a => <li key={a}>{a}</li>)}
                                </ul>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="photo-row" style={{ marginTop: '2.5rem' }}>
                    <figure className="photo-figure">
                        <LazyImg imageKey="hackathon" className="photo-img " alt="Dandyhacks 2023 Team"
                            style={{ width: "clamp(200px, 26vw, 400px)" }}
                            isBackgroundFilled={true}
                        />
                        <figcaption className="photo-caption">Dandyhacks 2023 — Turing Trouble</figcaption>
                    </figure>
                    <figure className="photo-figure">
                        <LazyImg imageKey="xcal" className="photo-img" alt="Excalibur Game Jam Team"
                            style={{ width: "clamp(200px, 26vw, 400px)" }}
                            isBackgroundFilled={true}
                        />
                        <figcaption className="photo-caption">Excalibur Game Jam 2025 — Flame's Legacy</figcaption>
                    </figure>
                </div>
            </section>

            <hr />



            {/* ── OUTSIDE THE CLASSROOM ────────────────────────────── */}
            <section className="about-section">
                <p className="section-eyebrow">Beyond the classroom</p>
                <h2 className="section-title">Life outside of code</h2>
                <p className="about-body-text">
                    I was part of the <span className="accent-purple">Music Interest Floor</span> and the{' '}
                    <span className="accent-blue">Rochester Design Hub</span> — two communities that shaped
                    how I think about creativity and collaboration. Outside of that, I'm usually:
                </p>

                <ul className="hobbies-list">
                    <li>Listening to music — especially Jazz &amp; Indie Pop</li>
                    <li>Reading sci-fi books</li>
                    <li>Creating art: sketches, 3D models, UI layouts</li>
                    <li>Building side projects for my friends and I to use</li>
                </ul>

                <div className="photo-row" style={{ marginTop: '2rem' }}>
                    <figure className="photo-figure">
                        <LazyImg imageKey="people"
                            className="photo-img"
                            isBackgroundFilled={true}
                            alt="Friends and I in the snow"
                            style={{ width: "clamp(200px, 26vw, 340px)", height: "clamp(200px, 26vw, 340px)" }}
                        />
                    </figure>
                    <figure className="photo-figure">
                        <LazyImg imageKey="people2"
                            className="photo-img"
                            isBackgroundFilled={true}
                            alt="Music Interest floor formal"
                            style={{ width: "clamp(200px, 26vw, 340px)", height: "clamp(200px, 26vw, 340px)" }}
                        />
                    </figure>
                    <figure className="photo-figure">
                        <LazyImg imageKey="out"
                            className="photo-img"
                            isBackgroundFilled={true}
                            alt="3D render I made"
                            style={{ width: "clamp(200px, 26vw, 340px)", height: "clamp(200px, 26vw, 340px)" }}
                        />
                    </figure>
                </div>
            </section>

            <hr />

            

            {/* ── CTA CARDS ──────────────────────────────────────── */}
            <section className="about-section">
                <p className="section-eyebrow">Keep exploring</p>
                <h2 className="section-title">What I've made</h2>

                <div className="passion-grid">
                    <InfoCard
                        title="My Projects"
                        desc="Practical AI systems, games, tools, and more."
                        linkText="Explore projects"
                        linkDir="/projects"
                        bg="gradient-purple"
                    />
                    <InfoCard
                        title="My Papers"
                        desc="AI detection, computational social choice, and critiques."
                        linkText="Explore papers"
                        linkDir="/papers"
                        bg="gradient-navy"
                    />
                </div>
            </section>

        </Layout>
    );
}

export default About;